module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finshed"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("猜你喜欢")]), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.jump(item)
        }
      }
    }, [_c('img', {
      staticClass: "img_left",
      attrs: {
        "src": item.img_left,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.p1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.p2))])]), _vm._v(" "), _c('img', {
      staticClass: "img_right",
      attrs: {
        "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/arrow-right.png",
        "alt": ""
      }
    })])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', [_c('p', [_vm._v("今天已答题")]), _vm._v(" "), _c('p', [_vm._v("明天不见不散")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-8b880280"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/Finshed/index.vue
// module id = 242
// module chunks = 1